/**
 * Custom hook for accessing the TeeTime context
 */
import { useContext } from 'react';
import { TeeTimeContext } from '../contexts/TeeTimeContext';

/**
 * Custom hook that provides access to the TeeTime context
 * @returns The TeeTime context
 */
export const useTeeTime = () => {
  const context = useContext(TeeTimeContext);
  
  if (!context) {
    throw new Error('useTeeTime must be used within a TeeTimeProvider');
  }
  
  return context;
};
